import { SetSurveyPaneDataPayload } from './actions';
import { SurveyPaneState } from './types';

const setSurveyPaneData = (
  state: SurveyPaneState,
  { survey, component }: SetSurveyPaneDataPayload
): SurveyPaneState => {
  return { ...state, survey, component };
};

export const surveyPaneOperations = {
  setSurveyPaneData,
};
